import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'react-components.Q1x2I6',
    defaultMessage: 'This must be a valid JSON value.',
  },
});
